import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  viewBox: "0 0 24 24",
  class: "w-3.5 h-3.5 shrink-0",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = { class: "text-[11px] leading-4 font-bold tracking-[1px] uppercase" }

import { mdiAlertOutline } from '@mdi/js'
import { apiHost, environment, isProduction } from '@/config/environment'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnvironmentStrip',
  props: {
    overlay: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (!_unref(isProduction))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        role: "alert",
        "aria-label": `Ambiente de teste ${_unref(environment)}, API ${_unref(apiHost)}`,
        "data-testid": "environment-strip",
        class: _normalizeClass([
      'flex items-center justify-center gap-1.5 px-3 py-1 bg-alert text-white',
      _ctx.overlay ? 'fixed top-0 inset-x-0 z-50 pointer-events-none' : 'shrink-0'
    ])
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          _createElementVNode("path", {
            d: _unref(mdiAlertOutline),
            fill: "currentColor"
          }, null, 8, _hoisted_3)
        ])),
        _createElementVNode("span", _hoisted_4, " Ambiente de teste · " + _toDisplayString(_unref(environment)), 1)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})